import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
export var DependencyManager = /*#__PURE__*/function () {
  function DependencyManager() {
    _classCallCheck(this, DependencyManager);
  }
  return _createClass(DependencyManager, null, [{
    key: "init",
    value: function init(dependencies) {
      var oldDependencies = this.dependencies || {};
      this.dependencies = Object.assign(Object.assign({}, oldDependencies), dependencies);
    }
  }, {
    key: "getAllDependencies",
    value: function getAllDependencies() {
      if (!this.dependencies) {
        throw new Error('Call init before getting dependencies');
      }
      return this.dependencies;
    }
  }, {
    key: "getSingleDependency",
    value: function getSingleDependency(selector, defaultValue, depTree) {
      var dependencies = depTree || this.getAllDependencies();
      if (typeof dependencies[selector] === 'undefined') {
        if (defaultValue) {
          return defaultValue;
        }
        throw new Error("Not able to find ".concat(selector));
      }
      return dependencies[selector];
    }
  }, {
    key: "getDependency",
    value: function getDependency(selector, defaultValue, depTree) {
      if (Array.isArray(selector)) {
        var deps = this.getSingleDependency(selector[0], defaultValue, depTree);
        if (deps && selector.length > 1) {
          return this.getDependency(selector.slice(1), defaultValue, deps);
        }
        return deps;
      }
      return this.getSingleDependency(selector, defaultValue);
    }
  }]);
}();
export default DependencyManager;